import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

export const CustomTransactionHeader = ({
  title,
  referenceNumber,
  statusChip,
  creatorName,
}) => {
  return (
    <Box>
      {/* First row: Title, Reference Number, Status - with flex wrap */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center"
        }}>
        <Typography
          sx={{
            fontSize: {
              xs: "1.25rem",
              sm: "2rem",
            },
            fontWeight: {
              xs: 500,
              sm: 400,
            },
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            alignItems: "center",
            flexShrink: 0
          }}>
          <Typography variant="h6">#{referenceNumber}</Typography>
          {statusChip}
        </Box>
      </Box>
      {/* Second row: Creator information */}
      {creatorName && (
        <Box sx={{
          mt: 1
        }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh: {creatorName}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

CustomTransactionHeader.propTypes = {
  title: PropTypes.string,
  referenceNumber: PropTypes.string,
  statusChip: PropTypes.node,
  creatorName: PropTypes.string,
};
